import React, { useState, useEffect, useMemo } from 'react';
import {
    MdEventNote,
    MdCheck,
    MdClose,
    MdNotes,
    MdPerson,
    MdAccessTime,
    MdContentCut,
    MdWarning,
    MdKeyboardArrowLeft,
    MdKeyboardArrowRight
} from 'react-icons/md';

import { appointmentsAPI } from 'services/api';

// --- SKELETON LOADER ---
const RequestsSkeleton = () => (
    <div className="flex flex-col gap-4 animate-pulse mt-4">
        {[1, 2, 3, 4].map((i) => (
            <div key={i} className="h-24 w-full rounded-2xl bg-gray-200 dark:bg-navy-700" />
        ))}
    </div>
);

// --- ANA BİLEŞEN ---
const StaffAppointmentRequests = () => {
    // --- STATELER (WORK-LOGIC BİREBİR) ---
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Buton Loader State'i (Hangi ID'li randevu, hangi işlemde (approve/reject) işleniyor?)
    const [processingAction, setProcessingAction] = useState({ id: null, type: null });

    // Not Modalı State'i
    const [noteModal, setNoteModal] = useState({ visible: false, text: '' });

    // Sayfalama (Pagination)
    const [currentPage, setCurrentPage] = useState(1);
    const PAGE_SIZE = 10;

    // --- API VE VERİ İŞLEME ---
    const fetchAppointmentRequests = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await appointmentsAPI.getMyAppointments();

            if (response.success) {
                // Sadece bekleyen (pending) randevu taleplerini filtrele
                const pendingRequests = (response.appointments || []).filter(
                    (app) => app.status === 'pending'
                );
                // Yeniden eskiye sırala
                pendingRequests.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

                setRequests(pendingRequests);
            } else {
                setError('Randevu talepleri alınırken bir sorun oluştu.');
            }
        } catch (err) {
            console.error("Talep çekilemedi:", err);
            setError('Sunucu bağlantısında hata oluştu.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAppointmentRequests();
    }, []);

    // --- İŞLEMLER (ONAYLA / REDDET) ---
    const handleAction = async (id, newStatus) => {
        try {
            setProcessingAction({ id, type: newStatus });
            await appointmentsAPI.updateStatus(id, newStatus);

            // İşlem başarılıysa listeden çıkar
            setRequests((prev) => prev.filter((req) => req.id !== id));

            // Eğer listede son elemansa ve silindiyse bir önceki sayfaya at
            if (currentPaginatedData.length === 1 && currentPage > 1) {
                setCurrentPage(p => p - 1);
            }

        } catch (err) {
            console.error("İşlem başarısız:", err);
            setError('İşlem sırasında bir hata oluştu.');
        } finally {
            setProcessingAction({ id: null, type: null });
        }
    };

    // --- SAYFALAMA HESAPLARI ---
    const totalPages = Math.max(1, Math.ceil(requests.length / PAGE_SIZE));

    const currentPaginatedData = useMemo(() => {
        const startIndex = (currentPage - 1) * PAGE_SIZE;
        return requests.slice(startIndex, startIndex + PAGE_SIZE);
    }, [requests, currentPage]);

    // --- RENDER ---
    return (
        <div className="mt-5 flex w-full flex-col gap-6 pb-20 animate-fadeIn">

            {/* 1. ÜST BAŞLIK */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 bg-white p-6 rounded-[20px] shadow-3xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none border border-gray-100 dark:border-white/10">
                <div className="flex items-center gap-4 w-full">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-50 text-brand-500 dark:bg-brand-400/10 dark:text-brand-400 flex-none">
                        <MdEventNote className="text-3xl" />
                    </div>
                    <div>
                        <h4 className="text-xl font-bold text-navy-700 dark:text-white">Randevu Talepleri</h4>
                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Müşterilerden gelen ve henüz onaylanmamış randevu talepleri.
                        </p>
                    </div>
                </div>
            </div>

            {error && (
                <div className="p-4 rounded-xl bg-red-50 text-red-600 border border-red-200 dark:bg-red-500/10 dark:border-red-500/20 dark:text-red-400 text-sm font-bold flex items-center gap-2 shadow-sm">
                    <MdWarning className="text-xl flex-none" /> {error}
                </div>
            )}

            {/* 2. LİSTELEME ALANI */}
            <div className="bg-white dark:bg-navy-800 rounded-[20px] shadow-sm border border-gray-100 dark:border-white/10 overflow-hidden">

                {/* Başlık ve Sayaç */}
                <div className="flex items-center justify-between p-6 border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20">
                    <h5 className="text-lg font-bold text-navy-700 dark:text-white">Bekleyen Talepler</h5>
                    <span className="px-3 py-1 bg-amber-50 text-amber-500 dark:bg-amber-400/10 dark:text-amber-400 rounded-lg text-sm font-bold">
            {requests.length} Yeni Talep
          </span>
                </div>

                <div className="p-4 md:p-6">
                    {loading ? (
                        <RequestsSkeleton />
                    ) : requests.length === 0 ? (
                        <div className="flex flex-col items-center justify-center py-16 opacity-60">
                            <MdEventNote className="text-6xl text-gray-300 dark:text-gray-600 mb-4" />
                            <h5 className="text-lg font-bold text-navy-700 dark:text-white mb-1">Yeni talep bulunmuyor.</h5>
                            <p className="text-sm font-medium text-gray-500 text-center">Şu anda onayınızı bekleyen herhangi bir randevu talebi yok.</p>
                        </div>
                    ) : (
                        <>
                            {/* --- MASAÜSTÜ GÖRÜNÜM (TABLO) --- */}
                            <div className="hidden md:block overflow-x-auto">
                                <table className="w-full text-left border-collapse">
                                    <thead>
                                    <tr>
                                        <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-widest border-b border-gray-100 dark:border-white/10">Tarih & Saat</th>
                                        <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-widest border-b border-gray-100 dark:border-white/10">Müşteri</th>
                                        <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-widest border-b border-gray-100 dark:border-white/10">Hizmet Detayı</th>
                                        <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-widest border-b border-gray-100 dark:border-white/10 text-right">İşlemler</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {currentPaginatedData.map((req) => {
                                        const isApproving = processingAction.id === req.id && processingAction.type === 'approved';
                                        const isRejecting = processingAction.id === req.id && processingAction.type === 'rejected';
                                        const isAnyProcessing = processingAction.id !== null;

                                        return (
                                            <tr key={req.id} className="hover:bg-gray-50/50 dark:hover:bg-navy-900/50 transition-colors border-b border-gray-50 dark:border-white/5 last:border-none">

                                                {/* Tarih Saat */}
                                                <td className="p-4">
                                                    <div className="flex flex-col">
                              <span className="text-sm font-black text-navy-700 dark:text-white flex items-center gap-1.5">
                                <MdAccessTime className="text-brand-500" />
                                  {req.appointment_time?.substring(0, 5) || "-"}
                              </span>
                                                        <span className="text-xs font-medium text-gray-500 mt-1">
                                {new Date(req.appointment_date).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}
                              </span>
                                                    </div>
                                                </td>

                                                {/* Müşteri */}
                                                <td className="p-4">
                                                    <div className="flex items-center gap-3">
                                                        <div className="h-10 w-10 flex-none rounded-full bg-brand-50 text-brand-500 dark:bg-brand-500/10 flex items-center justify-center font-bold">
                                                            {(req.customer?.name?.charAt(0) || 'M')}
                                                        </div>
                                                        <div className="flex flex-col">
                                <span className="text-sm font-bold text-navy-700 dark:text-white">
                                  {req.customer?.name} {req.customer?.surname}
                                </span>
                                                            <span className="text-[10px] font-medium text-gray-400 mt-0.5">
                                  {req.customer?.phone}
                                </span>
                                                        </div>
                                                    </div>
                                                </td>

                                                {/* Hizmet ve Not */}
                                                <td className="p-4">
                                                    <div className="flex flex-col items-start gap-1">
                              <span className="flex items-center gap-1.5 text-sm font-bold text-gray-600 dark:text-gray-300">
                                <MdContentCut className="text-gray-400" />
                                  {req.service?.name || "Bilinmeyen Hizmet"}
                              </span>
                                                        {req.note && (
                                                            <button
                                                                onClick={() => setNoteModal({ visible: true, text: req.note })}
                                                                className="flex items-center gap-1 mt-1 px-2 py-1 rounded-md bg-blue-50 text-blue-500 dark:bg-blue-500/10 dark:text-blue-400 text-[10px] font-bold uppercase tracking-wider hover:bg-blue-100 dark:hover:bg-blue-500/20 transition-colors"
                                                            >
                                                                <MdNotes /> Notu Oku
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>

                                                {/* İşlemler (Butonlar) */}
                                                <td className="p-4 text-right">
                                                    <div className="flex items-center justify-end gap-2">
                                                        {/* Onayla Butonu */}
                                                        <button
                                                            onClick={() => handleAction(req.id, 'approved')}
                                                            disabled={isAnyProcessing}
                                                            className="flex h-9 min-w-[90px] items-center justify-center gap-1.5 rounded-xl bg-green-500 text-white text-xs font-bold shadow-md shadow-green-500/20 hover:bg-green-600 disabled:opacity-50 transition-all active:scale-95 px-3"
                                                        >
                                                            {isApproving ? <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <><MdCheck className="text-sm"/> Onayla</>}
                                                        </button>

                                                        {/* Reddet Butonu */}
                                                        <button
                                                            onClick={() => {
                                                                if (window.confirm("Bu randevu talebini reddetmek istediğinize emin misiniz?")) {
                                                                    handleAction(req.id, 'rejected');
                                                                }
                                                            }}
                                                            disabled={isAnyProcessing}
                                                            className="flex h-9 w-9 items-center justify-center rounded-xl bg-red-50 text-red-500 border border-red-100 hover:bg-red-500 hover:text-white dark:bg-red-500/10 dark:border-red-900/30 dark:text-red-400 dark:hover:bg-red-500 dark:hover:text-white disabled:opacity-50 transition-all active:scale-95"
                                                            title="Reddet"
                                                        >
                                                            {isRejecting ? <div className="h-4 w-4 border-2 border-current border-t-transparent rounded-full animate-spin" /> : <MdClose className="text-lg" />}
                                                        </button>
                                                    </div>
                                                </td>

                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>

                            {/* --- MOBİL GÖRÜNÜM (KARTLAR) --- */}
                            <div className="flex flex-col gap-4 md:hidden">
                                {currentPaginatedData.map((req) => {
                                    const isApproving = processingAction.id === req.id && processingAction.type === 'approved';
                                    const isRejecting = processingAction.id === req.id && processingAction.type === 'rejected';
                                    const isAnyProcessing = processingAction.id !== null;

                                    return (
                                        <div key={req.id} className="flex flex-col p-5 rounded-[20px] bg-white dark:bg-navy-900 border border-gray-100 dark:border-white/5 shadow-sm">

                                            {/* Tarih ve Zaman Üst Bilgisi */}
                                            <div className="flex justify-between items-center mb-3 border-b border-gray-100 dark:border-white/5 pb-2">
                        <span className="text-sm font-black text-navy-700 dark:text-white flex items-center gap-1.5">
                          <MdAccessTime className="text-brand-500" />
                            {req.appointment_time?.substring(0, 5) || "-"}
                        </span>
                                                <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
                          {new Date(req.appointment_date).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short', year: 'numeric' })}
                        </span>
                                            </div>

                                            {/* Müşteri ve Hizmet Bilgisi */}
                                            <div className="flex items-start gap-3 mb-4">
                                                <div className="h-10 w-10 flex-none rounded-full bg-brand-50 text-brand-500 dark:bg-brand-500/10 flex items-center justify-center font-bold text-lg">
                                                    {(req.customer?.name?.charAt(0) || 'M')}
                                                </div>
                                                <div className="flex flex-col flex-1">
                          <span className="text-base font-bold text-navy-700 dark:text-white leading-tight">
                            {req.customer?.name} {req.customer?.surname}
                          </span>
                                                    <span className="text-[10px] font-medium text-gray-400 mb-1">{req.customer?.phone}</span>
                                                    <span className="flex items-center gap-1 text-xs font-bold text-gray-500 dark:text-gray-300">
                            <MdContentCut className="text-gray-400" /> {req.service?.name}
                          </span>
                                                </div>
                                            </div>

                                            {/* Not Varsa Göster */}
                                            {req.note && (
                                                <div className="mb-4 p-3 rounded-xl bg-gray-50 dark:bg-navy-800 border border-gray-100 dark:border-white/5 relative">
                                                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-brand-400 rounded-l-xl" />
                                                    <p className="text-xs font-medium text-gray-600 dark:text-gray-300 italic pl-1 line-clamp-2">"{req.note}"</p>
                                                    <button onClick={() => setNoteModal({ visible: true, text: req.note })} className="text-[10px] font-bold text-brand-500 mt-1 pl-1 underline">Tamamını Oku</button>
                                                </div>
                                            )}

                                            {/* Butonlar */}
                                            <div className="flex items-center gap-2 mt-auto pt-2">
                                                <button
                                                    onClick={() => {
                                                        if (window.confirm("Reddetmek istediğinize emin misiniz?")) {
                                                            handleAction(req.id, 'rejected');
                                                        }
                                                    }}
                                                    disabled={isAnyProcessing}
                                                    className="flex h-11 w-1/3 items-center justify-center gap-1 rounded-xl bg-red-50 text-red-500 font-bold hover:bg-red-500 hover:text-white dark:bg-red-500/10 dark:text-red-400 dark:hover:bg-red-500 dark:hover:text-white disabled:opacity-50 transition-all active:scale-95"
                                                >
                                                    {isRejecting ? <div className="h-5 w-5 border-2 border-current border-t-transparent rounded-full animate-spin" /> : <><MdClose className="text-lg"/> Ret</>}
                                                </button>

                                                <button
                                                    onClick={() => handleAction(req.id, 'approved')}
                                                    disabled={isAnyProcessing}
                                                    className="flex h-11 w-2/3 items-center justify-center gap-1.5 rounded-xl bg-green-500 text-white font-bold shadow-md shadow-green-500/20 hover:bg-green-600 disabled:opacity-50 transition-all active:scale-95"
                                                >
                                                    {isApproving ? <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" /> : <><MdCheck className="text-xl"/> Onayla</>}
                                                </button>
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>

                {/* 3. SAYFALAMA (PAGINATION) */}
                {!loading && totalPages > 1 && (
                    <div className="flex flex-col sm:flex-row items-center justify-between p-6 border-t border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20 gap-4">
            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">
              <span className="font-bold text-navy-700 dark:text-white">{requests.length}</span> talepten <span className="font-bold text-navy-700 dark:text-white">{(currentPage-1)*PAGE_SIZE + 1}-{Math.min(currentPage*PAGE_SIZE, requests.length)}</span> gösteriliyor.
            </span>

                        <div className="flex items-center gap-2">
                            <button
                                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                                className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 disabled:opacity-40 hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700 transition-all active:scale-95"
                            >
                                <MdKeyboardArrowLeft className="text-2xl" />
                            </button>

                            <div className="flex h-10 min-w-[40px] items-center justify-center rounded-xl bg-brand-500 text-white text-sm font-bold shadow-md px-3">
                                {currentPage}
                            </div>

                            <button
                                onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                                className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 disabled:opacity-40 hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700 transition-all active:scale-95"
                            >
                                <MdKeyboardArrowRight className="text-2xl" />
                            </button>
                        </div>
                    </div>
                )}

            </div>

            {/* --- MÜŞTERİ NOTU MODALI (GLASSMORPHISM) --- */}
            {noteModal.visible && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-navy-900/60 backdrop-blur-sm p-4 animate-fadeIn" onClick={() => setNoteModal({ visible: false, text: '' })}>
                    <div className="w-full max-w-sm bg-white dark:bg-navy-800 rounded-[24px] shadow-2xl overflow-hidden transform transition-all" onClick={e => e.stopPropagation()}>
                        <div className="flex items-center justify-between p-5 border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/50">
                            <h3 className="text-lg font-bold text-navy-700 dark:text-white flex items-center gap-2">
                                <MdNotes className="text-brand-500 text-xl" /> Müşteri Notu
                            </h3>
                            <button onClick={() => setNoteModal({ visible: false, text: '' })} className="text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors">
                                <MdClose className="text-2xl" />
                            </button>
                        </div>
                        <div className="p-6">
                            <div className="p-4 rounded-xl bg-brand-50 dark:bg-brand-400/10 border border-brand-100 dark:border-brand-500/20 relative">
                                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-brand-400 rounded-l-xl" />
                                <p className="text-sm font-medium text-navy-700 dark:text-gray-200 italic leading-relaxed pl-2">
                                    "{noteModal.text}"
                                </p>
                            </div>
                        </div>
                        <div className="p-5 pt-0 flex justify-end">
                            <button
                                onClick={() => setNoteModal({ visible: false, text: '' })}
                                className="px-6 py-2.5 rounded-xl bg-gray-100 dark:bg-navy-700 text-gray-600 dark:text-white text-sm font-bold hover:bg-gray-200 dark:hover:bg-navy-600 transition-colors"
                            >
                                Kapat
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fadeIn { animation: fadeIn 0.3s ease-out; }
      `}</style>

        </div>
    );
};

export default StaffAppointmentRequests;